import {
  CentralReservationOfficeUserListItemDto,
  UnitAssignmentListItem,
  UserPreferencesDetails,
} from '@ac/library-api';
import { Form } from '@ac/react-infrastructure';

export interface PrestepDictionaries {
  croUnits: CentralReservationOfficeUserListItemDto[];
  units: UnitAssignmentListItem[];
}

export interface PrestepUserPreferencesForm extends UserPreferencesDetails {
  keepAsDefault?: boolean;
}

export const PrestepForm = Form<PrestepUserPreferencesForm>;
